module.exports = __webpack_public_path__ + "img/computerIcon.577f45a4.png";